export default "__VITE_ASSET__C4ltK67y__"